// extracted by mini-css-extract-plugin
module.exports = {"AdminLink":"AdminButton_AdminLink__nOJnc","AdminButton":"AdminButton_AdminButton__8UPcJ","AdminIcon":"AdminButton_AdminIcon__2IxkS","AdminText":"AdminButton_AdminText__1H1tI"};